import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import kbsCool from '../../assets/logo/KBS_Cool_FM.png';
import sbsNews from '../../assets/logo/SBS_News_logo.png';
import kbs from '../../assets/logo/KBS_logo_2023.png';
import ebs from '../../assets/logo/EBS_Logo.png';
import toonation from '../../assets/logo/toonation.png';

const PARTNERS = [
  { src: kbsCool, alt: 'KBS Cool FM' },
  { src: sbsNews, alt: 'SBS News' },
  { src: kbs, alt: 'KBS' },
  { src: ebs, alt: 'EBS' },
  { src: toonation, alt: 'Toonation' },
];

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(8, 4),
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    '@media (max-width:600px)': { padding: theme.spacing(6, 3) },
  },
  inner: {
    maxWidth: 1280,
    margin: '0 auto',
  },
  label: {
    textAlign: 'center',
    fontSize: 12,
    letterSpacing: '0.32em',
    color: 'rgba(255,255,255,0.5)',
    marginBottom: theme.spacing(5),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    gap: theme.spacing(5),
  },
  logo: {
    height: 44,
    objectFit: 'contain',
    opacity: 0.8,
    filter: 'grayscale(0.15)',
    transition: 'opacity 0.2s, filter 0.2s',
    '&:hover': { opacity: 1, filter: 'grayscale(0)' },
    '@media (max-width:600px)': { height: 32 },
  },
}));

export default function Partners() {
  const classes = useStyles();
  return (
    <Box component="section" className={classes.root}>
      <Box className={classes.inner}>
        <Typography className={classes.label}>OUR PARTNERS</Typography>
        <Box className={classes.row}>
          {PARTNERS.map((p) => (
            <img key={p.alt} src={p.src} alt={p.alt} className={classes.logo} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
